import { isFunction, findIndex, isEqual } from 'lodash'
import { isEmptyArray } from './utils/tools'
import { COMMON_PROPS } from './props/common'
import { MULTIPLE_PROPS } from './props/multiple'
import './style/single.scss'
import './style/multiple.scss'

export default {
  props: {
    ...COMMON_PROPS,
    ...MULTIPLE_PROPS
  },
  data() {
    return {
      borderActive: false,
      currentValue: ''
    }
  },
  render(h) {
    const props = this.$props

    // 作用域插槽
    const renderSlotProps = (slotProps) => {
      const label = this.$props.labelKeys.reduce((str, key) => {
        str += slotProps.item[key] ? (slotProps.item[key] + '，') : ''
        return str
      }, '').slice(0, -1)
      const findRowKeyValue = this.findRowKeyValue
      const selected = this.value.findIndex(obj => isEqual(findRowKeyValue(obj), findRowKeyValue(slotProps.item))) > -1
      return <div class={{
        'kye-employee-search__option': slotProps && slotProps.item && slotProps.item.optionDisabled,
        'kye-employee-search-item': true,
        'selected': selected,
      }}>
        {
          label
        }
      </div>
    }

    const renderOptionSlot = this.$scopedSlots && this.$scopedSlots.default ? this.$scopedSlots.default : renderSlotProps

    const autocompleteAttrs = {
      attrs: {
        readonly: props.readonly
      },
      props: {
        ...(props.autocompleteAttrs || {}),
        value: this.currentValue,
        fetchSuggestions: this.handleFetchSuggestionsEvent,
        'popper-class': (this.$attrs.popperClass || '') + ' kye-employee-search',
        placeholder: props.multiple && this.value.length ? '' : props.placeholder,
        triggerOnFocus: false, // 是否在输入框 focus 时显示建议列表
        disabled: props.disabled
      },
      class: 'kye-employee-search-autocomplete-input',
      style: {
        width: '100%'
      },
      on: {
        input: this.handleInput,
        focus: this.handleFocus,
        blur: this.handleBlur
      },
      ref: 'autocomponentRef',
      scopedSlots: {
        default: slotProps => renderOptionSlot(slotProps)
      }
    }

    return (
      <div
        class={{
          'kye-employee-search-container': true,
          'multiple': true,
          'border-active': this.borderActive,
          'disabled': props.disabled,
          'has-value': !!this.value.length
        }}
        on-keydown={e => this.multipleContainerKeyDown(e)}>
        {this.value.length ? (
          <div class="tags-wrap">
            <span class="el-tag el-tag--info el-tag--mini tags-text">
              <span class="el-select__tags-text">{this.value[0][this.valueKey]}</span>
              {props.disabled ? null : (
                <i class="el-tag__close el-icon-close" on-click={() => this.deleteTag(this.value[0])}></i>
              )}
            </span>
            {this.value.length > 1 ? (
              <span class="el-tag el-tag--info el-tag--mini ml-6">
                <span class="el-select__tags-text">+{this.value.length - 1}</span>
              </span>
            ) : null}
          </div>
        ) : null}
        <el-autocomplete {...autocompleteAttrs}></el-autocomplete>
      </div>
    )
  },
  mounted() {
    this.overrideAutoCompleteEvent()
  },
  methods: {
    overrideAutoCompleteEvent() {
      // 重写select让其支持多选模式
      this.$refs.autocomponentRef.select = this.multipleSelect
      this.$refs.autocomponentRef.$refs.suggestions.referenceElm = this.$el
    },
    multipleContainerKeyDown(event) {
      if (event.key === 'Backspace' || event.key === 'Delete') {
        this.deletePreTag(event)
      }
    },
    deletePreTag(event) {
      if (!this.$refs.autocomponentRef.$refs.input.currentValue && this.value.length) {
        const value = this.value.slice()
        const lastItem = value[value.length - 1]
        value.pop()
        this.$emit('input', value)
        this.$emit('change', value)
        this.$emit('select', lastItem, value)
      }
    },
    deleteTag(item) {
      const index = findIndex(this.value, obj => isEqual(obj, item))
      if (index > -1) {
        this.value.splice(index, 1)
        this.$emit('input', this.value)
        this.$emit('remove-tag', item)
        this.$emit('change', this.value)
        this.$emit('select', item, this.value)
      }
    },
    findRowKeyValue (item) {
      return this.$props.rowKey ? item[this.$props.rowKey] : item
    },
    multipleSelect (item) {
      const findRowKeyValue = this.findRowKeyValue
      const optionIndex = this.value.findIndex((obj) => findRowKeyValue(obj) === findRowKeyValue(item))
      if (optionIndex > -1) {
        this.value.splice(optionIndex, 1)
      } else if (this.multipleLimit <= 0 || this.value.length < this.multipleLimit) {
        this.value.push(item)
      }
      this.$emit('input', this.value)
      this.$emit('change', this.value)
      this.$emit('select', item, this.value)
      if (this.$props.filterable && !this.$props.reserveKeyword) {
        this.currentValue = ''
      }
    },
    changeBorderActive(val) {
      this.borderActive = val
    },
    changeCurrentValue(val) {
      this.currentValue = val
    },
    handleInput(val) {
      this.$emit('inputChange', val)
      if (val) {
        val = val.trim()
      }
      this.changeCurrentValue(val)
    },
    handleFocus() {
      this.$emit('focus')
      this.changeBorderActive(true)
      // 展示已选的数据下拉选择。在多选的时候
      const suggestions = this.$refs.autocomponentRef.suggestions || []
      if (
        this.value.length &&
        (!suggestions.length || (suggestions.length && suggestions.length !== this.value.length))
      ) {
        this.setOptions(this.value)
      }
      if (!this.currentValue && !this.value.length && suggestions.length) {
        this.setOptions([])
      }
    },
    handleBlur(e) {
      this.changeBorderActive(false)
      this.setLoading(false)
      this.changeCurrentValue('')
      this.$emit('blur', this.currentValue, e)
    },
    handleFetchSuggestionsEvent(val, cb) {
      if (isFunction(this.$props.fetchSuggestions)) {
        const fn = data => {
          const emptyArray = isEmptyArray(data)
          if (!data || emptyArray) {
            this.setLoading(false)
            if (emptyArray) {
              this.setOptions([])
            }
          } else {
            cb(data)
          }
        }
        const result = this.$props.fetchSuggestions(val)
        if (result && result.then) {
          result.then(data => {
            fn(data)
          })
        } else {
          fn(result)
        }
      }
    },
    setLoading(val) {
      this.$refs.autocomponentRef.loading = val
    },
    setOptions(val = []) {
      this.$refs.autocomponentRef.suggestions = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-employee/multiple.js